import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import thankyou from "@/i18n/thankyou.json";
import { ArrowLeft } from "lucide-react";

export default function ThankYou() {
  return (
    <main className="min-h-screen bg-[#F8F7F4] text-[#121316] flex items-center" style={{ wordBreak: "break-word" }}>
      <div className="max-w-4xl mx-auto px-5 sm:px-8 lg:px-12 py-32 lg:py-40 w-full">
        <motion.p
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="text-[11px] font-mono uppercase tracking-[0.24em] text-[#C27835]"
        >
          {thankyou.eyebrow}
        </motion.p>
        <motion.h1
          initial={{ y: 40, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 1, ease: [0.16, 1, 0.3, 1], delay: 0.1 }}
          className="mt-6 font-serif text-6xl sm:text-8xl lg:text-[132px] leading-[0.95] tracking-tight"
        >
          {thankyou.title}
        </motion.h1>
        <motion.h2
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.9, delay: 0.35 }}
          className="mt-8 font-serif italic text-3xl sm:text-4xl text-[#3B3C42]"
        >
          {thankyou.heading}
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.5 }}
          className="mt-8 max-w-2xl text-lg leading-relaxed text-[#52535A] font-light"
        >
          {thankyou.body}
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.7 }}
          className="mt-10 flex flex-wrap items-center gap-4"
        >
          <Link
            to="/"
            data-testid="thankyou-back-home"
            className="inline-flex items-center gap-2 bg-[#121316] text-[#F8F7F4] rounded-full px-6 py-3.5 text-sm font-medium hover:bg-[#C27835] transition-colors duration-300"
          >
            <ArrowLeft size={16} />
            {thankyou.backHome}
          </Link>
          <span className="text-[11px] font-mono uppercase tracking-[0.24em] text-[#7A7B82]">{thankyou.meta}</span>
        </motion.div>
      </div>
    </main>
  );
}
